import api from './axios'

export function createGroup(payload) {
  return api.post('/groups', payload).then(r => r.data)
}

export function listGroups() {
  return api.get('/groups').then(r => r.data)
}

export function getGroup(id) {
  return api.get(`/groups/${id}`).then(r => r.data)
}

export function updateGroupName(id, payload) {
  return api.put(`/groups/${id}`, payload).then(r => r.data)
}

export function addGroupMembers(id, payload) {
  return api.post(`/groups/${id}/members`, payload).then(r => r.data)
}

export function deleteGroup(id) {
  return api.delete(`/groups/${id}`)
}

export function removeGroupMember(groupId, memberId) {
  return api.delete(`/groups/${groupId}/members/${memberId}`).then(r => r.data)
}

export function leaveGroup(groupId) {
  return api.delete(`/groups/${groupId}/members/me`).then(r => r.data)
}

export function updateGroupMemberEmail(groupId, memberId, payload) {
  return api
    .patch(`/groups/${groupId}/members/${memberId}/email`, payload)
    .then(r => r.data)
}

export function inviteGroupMember(groupId, memberId) {
  return api
    .post(`/groups/${groupId}/members/${memberId}/invite`)
    .then(r => r.data)
}

export function listMyInvitations() {
  return api.get('/groups/invitations/mine').then(r => r.data)
}

export function listSentPendingInvitations(groupIds = []) {
  return api
    .post('/groups/invitations/pending-sent', { groupIds })
    .then(r => r.data)
}

export function acceptInvitation(invitationId) {
  return api
    .patch(`/groups/invitations/${invitationId}/accept`)
    .then(r => r.data)
}

export function rejectInvitation(invitationId) {
  return api
    .patch(`/groups/invitations/${invitationId}/reject`)
    .then(r => r.data)
}
